import { post, get, put, downloadBlob, postRaw, destroy } from './client';
import { makeGrowerPath } from './utils';

export function applyLpkInstance(growerId, id, isApplied) {
  return put(`/growers/${growerId}/lpk/prescriptions/${id}`, { isApplied });
}

export function adjustLpkInstance(growerId, id, adjustments) {
  return post(`/growers/${growerId}/lpk/prescriptions/${id}`, adjustments);
}

export function getLpkInstances(growerId) {
  return get(`/growers/${growerId}/lpk/prescriptions`);
}

export function deleteLpkInstances(growerId, ids) {
  return destroy(`/growers/${growerId}/lpk/prescriptions`, { ids });
}

export function renameLpkInstances(growerId, newNames) {
  return put(`/growers/${growerId}/lpk/prescriptions`, newNames);
}

export function getLpkInstance(growerId, id) {
  return get(`/growers/${growerId}/lpk/prescriptions/${id}`);
}

export function runAllLpk(props) {
  return post(makeGrowerPath(`/lpk/run`), props);
}

export function runLpk(growerId, params) {
  return post(`/growers/${growerId}/lpk/prescriptions`, params);
}

export function getAvailableYield(growerId, aaids) {
  return get(`/lpk/available-yield/${growerId}?a=${aaids.join(',')}`);
}

export function getLimeStats(field) {
  return get(makeGrowerPath(`/lpk/lime/${field.prescription.id}/stats`));
}

export function getPhosphorusStats(field) {
  return get(makeGrowerPath(`/lpk/phosphorus/${field.prescription.id}/stats`));
}

export function getPotassiumStats(field) {
  return get(makeGrowerPath(`/lpk/potassium/${field.prescription.id}/stats`));
}

export function setLpkLimeAdjustmentFactor(field, adjustmentFactor) {
  return post(
    makeGrowerPath(`/lpk/lime/${field.prescription.id}/field-adjustment`),
    {
      adjustmentFactor,
    },
  );
}

export function setLpkPhosphorusAdjustmentFactor(field, adjustmentFactor) {
  return post(
    makeGrowerPath(`/lpk/phosphorus/${field.prescription.id}/field-adjustment`),
    {
      adjustmentFactor,
    },
  );
}

export function setLpkPotassiumAdjustmentFactor(field, adjustmentFactor) {
  return post(
    makeGrowerPath(`/lpk/potassium/${field.prescription.id}/field-adjustment`),
    {
      adjustmentFactor,
    },
  );
}

export function getLimeAdjustedGroups(field) {
  return get(
    makeGrowerPath(`/lpk/lime/${field.prescription.id}/group-adjustments`),
  );
}

export function setLpkLimeGroupAdjustment(field, groupAdjustments) {
  return post(
    makeGrowerPath(`/lpk/lime/${field.prescription.id}/group-adjustments`),
    groupAdjustments,
  );
}

export function getPhosphorusAdjustedGroups(field) {
  return get(
    makeGrowerPath(
      `/lpk/phosphorus/${field.prescription.id}/group-adjustments`,
    ),
  );
}

export function setLpkPhosphorusGroupAdjustment(field, groupAdjustments) {
  return post(
    makeGrowerPath(
      `/lpk/phosphorus/${field.prescription.id}/group-adjustments`,
    ),
    groupAdjustments,
  );
}

export function getPotassiumAdjustedGroups(field) {
  return get(
    makeGrowerPath(`/lpk/potassium/${field.prescription.id}/group-adjustments`),
  );
}

export function setLpkPotassiumGroupAdjustment(field, groupAdjustments) {
  return post(
    makeGrowerPath(`/lpk/potassium/${field.prescription.id}/group-adjustments`),
    groupAdjustments,
  );
}

export function downloadLpkShapefile(growerId, aaids, fieldSelection) {
  return downloadBlob(
    `/lpk/${growerId}/shapefile/${fieldSelection.join('')}`,
    aaids,
  );
}

export function downloadLpkShapefiles(growerId, ids, fieldSelection) {
  return postRaw(`/lpk/${growerId}/shapefile/${fieldSelection}`, ids, {
    responseType: 'blob',
  });
}

export function downloadLpkCsv(growerId, ids) {
  return postRaw(`/growers/${growerId}/lpk/csv`, ids, {
    responseType: 'blob',
  });
}

export function downloadLpkPdfs(growerId, ids) {
  return postRaw(`/growers/${growerId}/lpk/prescriptions/pdf`, ids, {
    responseType: 'blob',
  });
}
